import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { getPrincipals, type ListPrincipalsParams } from '@/api/principals';

/** Paginated principals query for the Directory Users tab and KPI tiles. */
export function usePrincipals(params: ListPrincipalsParams = {}) {
  return useQuery({
    queryKey: queryKeys.principals.list(params as Record<string, unknown>),
    queryFn: () => getPrincipals(params),
  });
}
